// import React from 'react';
// import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import { useMyContext } from '../context/MyContext';

// const B2BProtectedRoute = () => {
//   const { isB2BMode } = useMyContext();
//   const location = useLocation();

//   // If not in B2B mode, redirect to the main dashboard
//   if (!isB2BMode) {
//     return <Navigate to="/dashboard" state={{ from: location }} replace />;
//   }

//   // If in B2B mode, allow access to B2B routes
//   return <Outlet />;
// };

// export default B2BProtectedRoute;




// import React, { useEffect } from 'react';
// import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import { useMyContext } from '../context/MyContext';

// const B2BProtectedRoute = () => {
//   const { isB2BMode, setIsB2BMode } = useMyContext();
//   const location = useLocation();

//   // Effect to set B2B mode based on URL path when component mounts or URL changes
//   useEffect(() => {
//     const isB2BPath = location.pathname.startsWith('/b2b');
    
//     // If we're on a B2B path but isB2BMode is false, set it to true
//     if (isB2BPath && !isB2BMode) {
//       setIsB2BMode(true);
//     }
//   }, [location.pathname, isB2BMode, setIsB2BMode]);

//   // If not in B2B mode, redirect to the main dashboard
//   if (!isB2BMode) {
//     return <Navigate to="/dashboard" state={{ from: location }} replace />;
//   }

//   // If in B2B mode, allow access to B2B routes
//   return <Outlet />;
// };

// export default B2BProtectedRoute;


import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMyContext } from '../context/MyContext'; 

const B2BProtectedRoute = () => {
  const { isB2BMode, toggleB2BMode } = useMyContext();
  const location = useLocation();

  // Effect to set B2B mode based on URL path when component mounts or URL changes
  useEffect(() => {
    const isB2BPath = location.pathname.startsWith('/b2b');
    
    // If we're on a B2B path but isB2BMode is false, set it to true
    if (isB2BPath && !isB2BMode) {
      toggleB2BMode(true);
    }
  }, [location.pathname, isB2BMode, toggleB2BMode]);

  // If not in B2B mode, redirect to the main dashboard
  if (!isB2BMode) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  // If in B2B mode, allow access to B2B routes
  return <Outlet />;
};

export default B2BProtectedRoute;